import { render, staticRenderFns } from "./codePupop.vue?vue&type=template&id=4c28b1b8&scoped=true&"
import script from "./codePupop.vue?vue&type=script&lang=js&"
export * from "./codePupop.vue?vue&type=script&lang=js&"
import style0 from "./codePupop.vue?vue&type=style&index=0&id=4c28b1b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c28b1b8",
  null
  
)

export default component.exports